import React from "react";
import { QRCodeSVG } from "qrcode.react";
import { companyLogoUrl } from "../lib/erp";
import { deliveryAddressText } from "../lib/packingSlip";

// One slip body. mode: "a4" (default) or "thermal".
function SlipBody({ slip, company, compact }) {
  const to = slip || {};
  const address = deliveryAddressText(to);
  const logo = (company || {}).print_show_logo !== false ? companyLogoUrl(company) : null;
  return (
    <div className={`bg-white text-slate-900 ${compact ? "p-4" : "p-6"} font-sans text-[12px] leading-snug`} style={{ border: "1px dashed #94a3b8" }}>
      <div className="flex items-start justify-between border-b-2 border-slate-800 pb-2">
        <div>
          {logo && <img src={logo} alt="" style={{ maxHeight: "40px", maxWidth: "180px", objectFit: "contain", marginBottom: "4px" }} />}
          <div className="font-heading text-base font-bold">{company?.name || "VGRUPS Health Care"}</div>
          <div className="text-[11px] text-slate-600">Packing Slip</div>
        </div>
        <div className="text-right">
          <div className="font-mono text-sm font-semibold">{to.transport_no}</div>
          {to.bill_no && <div className="text-[10px] text-slate-500">Bill: {to.bill_no}</div>}
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3 mt-3 text-[11px]">
        <div>
          <div className="text-[9px] uppercase tracking-wider text-slate-500 font-semibold">From (Consignor)</div>
          <div className="font-semibold">{to.from_name || company?.name}</div>
          <div className="text-slate-600">{to.from_address}</div>
          <div className="text-slate-600">{[to.from_city, to.from_state, to.from_pincode].filter(Boolean).join(", ")}</div>
        </div>
        <div>
          <div className="text-[9px] uppercase tracking-wider text-slate-500 font-semibold">To (Deliver To)</div>
          <div className="font-semibold">{to.to_name}</div>
          <div className="text-slate-600">{to.to_address}</div>
          <div className="text-slate-600">{[to.to_city, to.to_state, to.to_pincode].filter(Boolean).join(", ")}</div>
          {to.to_phone && <div className="text-slate-600">Ph: {to.to_phone}</div>}
        </div>
      </div>
      <div className="grid grid-cols-3 gap-3 mt-3 text-[11px] border-t pt-2">
        <div><span className="text-slate-500">Transporter:</span> {to.transporter || "—"}</div>
        <div><span className="text-slate-500">Vehicle:</span> {to.vehicle_no || "—"}</div>
        <div><span className="text-slate-500">Packages:</span> {to.packages || 1}{to.weight ? ` · ${to.weight}kg` : ""}</div>
      </div>
      <div className="mt-3 flex flex-col items-center border-t pt-2">
        {address ? (
          <>
            <QRCodeSVG value={address} size={compact ? 112 : 136} level="L" marginSize={2}
              title="Deliver To address" data-testid="packing-slip-address-qr" />
            <div className="text-[10px] text-slate-600 mt-1">Scan for delivery address</div>
          </>
        ) : (
          <div className="text-[10px] text-slate-600">Delivery address not available</div>
        )}
      </div>
    </div>
  );
}

// mode: "a4" prints two slips per A4 page (two-up), "thermal" prints one narrow slip.
export default function PackingSlipPrint({ slip, company, mode = "a4" }) {
  if (!slip) return null;
  const isThermal = mode === "thermal";
  const width = isThermal ? "72mm" : "190mm";
  return (
    <div id="print-area" data-print-format={isThermal ? "thermal" : "a4"} data-print-wide={isThermal ? "72" : undefined} style={{ width, margin: "0 auto" }} className="bg-white">
      {isThermal ? (
        <SlipBody slip={slip} company={company} compact />
      ) : (
        <div className="grid grid-rows-2 gap-4" style={{ minHeight: "255mm" }}>
          <SlipBody slip={slip} company={company} />
          <SlipBody slip={slip} company={company} />
        </div>
      )}
    </div>
  );
}
